import { InjectionToken, Signal } from '@angular/core';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

/**
 * Optional token that provides the list of supported/enabled scopes of practice.
 * When provided, the scope-of-practice-select component uses it to filter options.
 * When not provided, all scopes are shown.
 *
 * Example usage in app.config.ts:
 * ```
 * { provide: SUPPORTED_SCOPES, useFactory: () => {
 *     const ctx = inject(FacilityContextService);
 *     return computed(() => ctx.facility()?.supportedScopes ?? []);
 *   }
 * }
 * ```
 */
export const SUPPORTED_SCOPES = new InjectionToken<
  Signal<ScopeOfPracticeEnum[]>
>('SUPPORTED_SCOPES');
